import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface WorkspaceState {
  /** The workspace the user last selected from the Workspace modal. Persisted so a refresh doesn't lose context. */
  activeWorkspaceUuid: string | null;
  activeWorkspaceName: string | null;
  setActiveWorkspace: (uuid: string, name: string) => void;
  clearActiveWorkspace: () => void;
}

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      activeWorkspaceUuid: null,
      activeWorkspaceName: null,
      setActiveWorkspace: (uuid, name) =>
        set({ activeWorkspaceUuid: uuid, activeWorkspaceName: name }),
      clearActiveWorkspace: () => set({ activeWorkspaceUuid: null, activeWorkspaceName: null }),
    }),
    {
      name: 'workspace-storage',
    },
  ),
);
